import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild
} from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-highlight-on-change',
    templateUrl: './highlight-on-change.component.html',
    styleUrls: ['./highlight-on-change.component.scss'],
    standalone: false
})
export class HighlightOnChangeComponent implements OnChanges {

  static readonly HIGHLIGHT_TIMEOUT = 1000;
  @ViewChild('valueField') valueFieldEl: ElementRef;
  @Input() value: string;

  static addAndRemoveTransitionClass(nativeElement: HTMLElement) {
    nativeElement?.classList?.add('value-change-transition');
    setTimeout(() => {
      nativeElement?.classList?.remove('value-change-transition');
    }, HighlightOnChangeComponent.HIGHLIGHT_TIMEOUT);
  }

  ngOnChanges(changes: SimpleChanges) {
    if(!(changes.value.isFirstChange()) && changes.value.currentValue !== changes.value.previousValue) {
      HighlightOnChangeComponent.addAndRemoveTransitionClass(this.valueFieldEl?.nativeElement);
    }
  }

}
